<div class="container-upcoming-events bg-neutral-95 no-print" *ngIf="block">
    <div class="container pb-5 pb-lg-0">
        <app-header-event [headerData]="headerData"></app-header-event>
        <!-- DESKTOP -->
        <div *ngIf="eventsDataArrayBig" class="container-upcoming-events__container-card d-none d-md-flex justify-content-between align-items-center">
            <!-- Box left -->
            <div class="container-upcoming-events__container-card__left-box col-6 position-relative me-3">
                <div class="container-bg">
                    <img loading="lazy" class="w-100" *ngIf="eventsDataArrayBig.field_immagine" [src]="setImage(eventsDataArrayBig.field_immagine)"
                        [alt]="altImage" [width]="widthImage" [height]="heightImage">
                    <img loading="lazy" class="w-100" *ngIf="eventsDataArrayBig.field_immagine_importata"
                        [src]="this.domainWebsite + eventsDataArrayBig.field_immagine_importata" alt="Event | Lumsa">
                    <div *ngIf="eventsDataArrayBig.field_tipologia_evento"
                        class="position-absolute text-white container-upcoming-events__container-card__left-box__container-badge">
                        <p class="m-0 ls-label-small-semibold text-neutral-A1 text-uppercase">
                            {{ eventsDataArrayBig.field_tipologia_evento }}
                        </p>
                    </div>
                    <div class="position-absolute container-upcoming-events__container-card__left-box__icon-social"
                        (click)="openModaleShare()">
                        <img loading="lazy" src="../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon" width="24" 
                        height="24">
                    </div>
                    <div *ngIf="eventsDataArrayBig.content_type === 'Archivio Evento'"
                        class="position-absolute text-white container-upcoming-events__container-card__left-box__title">
                        <div *ngIf="eventDate" class="container-upcoming-events__container-card__left-box__title__date">
                            <p *ngIf="eventDate.inizio && eventDate.fine" class="m-0 ls-label-large ms-1">
                                {{"BLOCK.SAMPLE_EVENTS.FROM" | translate}}
                            </p>
                            <p *ngIf="eventDate.inizio" class="m-0 text-garamond ls-label-xxx-large text-uppercase"  [attr.role]="'heading'">
                                {{ eventDate.inizio | localizedDate: 'dd MMM YY' }}
                            </p>
                            <p *ngIf="eventDate.fine" class="m-0 ls-label-large ms-1">
                                {{"BLOCK.SAMPLE_EVENTS.TO" | translate}}</p>
                            <p *ngIf="eventDate.fine" class="m-0 text-garamond ls-label-xxx-large text-uppercase" [attr.role]="'heading'">
                                {{ eventDate.fine | localizedDate: 'dd MMM YY' }}
                            </p>
                        </div>
                    </div>
                    <div *ngIf="eventsDataArrayBig.field_tipologia_evento === 'Online'"
                        class="position-absolute text-white container-upcoming-events__container-card__left-box__title">
                        <div class="container-upcoming-events__container-card__left-box__title__month">
                            <p *ngIf="eventDate.inizio" class="mb-2 text-garamond ls-label-xxx-large text-uppercase">
                                {{ eventDate.inizio | localizedDate: 'dd MMM YY' }}
                            </p>
                        </div>
                        <div class="container-upcoming-events__container-card__left-box__title__hours">
                            <p class="m-0 ls-label-large">
                                <ng-container *ngIf="eventsDataArrayBig.field_orario_inizio && eventsDataArrayBig.field_orario_inizio.trim()">{{"BLOCK.SAMPLE_EVENTS.FROM_HOUR" | translate}} {{ eventsDataArrayBig.field_orario_inizio }}</ng-container>
                                <ng-container *ngIf="eventsDataArrayBig.field_orario_fine && eventsDataArrayBig.field_orario_fine.trim()"> {{"BLOCK.SAMPLE_EVENTS.TO_HOUR" | translate}} {{ eventsDataArrayBig.field_orario_fine }}</ng-container>
                            </p>
                        </div>
                        <div *ngIf="eventsDataArrayBig.field_nome_location"
                            class="container-upcoming-events__container-card__left-box__title__location">
                            <p class="m-0 ls-label-large-semibold">{{ eventsDataArrayBig.field_nome_location }}</p>
                        </div>
                    </div>
                    <div *ngIf="eventsDataArrayBig.field_tipologia_evento === 'In presenza' || eventsDataArrayBig.field_tipologia_evento === 'In presenza/Online'"
                        class="position-absolute text-white container-upcoming-events__container-card__left-box__title">
                        <div class="container-upcoming-events__container-card__left-box__title__date">
                            <p *ngIf="eventDate.inizio && eventDate.fine" class="m-0 ls-label-large ms-1">
                                {{"BLOCK.SAMPLE_EVENTS.FROM" | translate}}
                            </p>
                            <p *ngIf="eventDate.inizio" class="m-0 text-garamond ls-label-xxx-large text-uppercase" [attr.role]="'heading'">
                                {{ eventDate.inizio | localizedDate: 'dd MMM YY' }}
                            </p>
                            <p *ngIf="eventDate.fine" class="m-0 ls-label-large ms-1">
                                {{"BLOCK.SAMPLE_EVENTS.TO" | translate}}
                            </p>
                            <p *ngIf="eventDate.fine" class="m-0 text-garamond ls-label-xxx-large text-uppercase" [attr.role]="'heading'">
                                {{ eventDate.fine| localizedDate: 'dd MMM YY' }}
                            </p>
                        </div>
                        <div class="container-upcoming-events__container-card__left-box__title__hours">
                            <p class="m-0 ls-p ms-1">
                                <ng-container *ngIf="eventsDataArrayBig.field_orario_inizio && eventsDataArrayBig.field_orario_inizio.trim()">{{"BLOCK.SAMPLE_EVENTS.FROM_HOUR" | translate}} {{ eventsDataArrayBig.field_orario_inizio }}</ng-container>
                                <ng-container *ngIf="eventsDataArrayBig.field_orario_fine && eventsDataArrayBig.field_orario_fine.trim()"> {{"BLOCK.SAMPLE_EVENTS.TO_HOUR" | translate}} {{ eventsDataArrayBig.field_orario_fine }}</ng-container>
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="setTitle(eventsDataArrayBig.field_titolo)"
                    class="position-absolute d-flex flex-column justify-content-between container-upcoming-events__container-card__left-box__box-bottom">
                    <div>
                        <p
                            class="ls-label-small-semibold text-uppercase container-upcoming-events__container-card__left-box__box-bottom__category ls-label-small-semibold text-neutral-60 text-uppercase">
                            {{ setLabelCategoryBig(eventsDataArrayBig.field_tassonomia_area_universita) }}</p>
                        <a *ngIf="!nodeService.verifyLinkExternal(setTitle(eventsDataArrayBig.field_titolo).link)"
                            [routerLink]="navigationService.splitUrlRouterLink(setTitle(eventsDataArrayBig.field_titolo).link).path" [queryParams]="navigationService.splitUrlRouterLink(setTitle(eventsDataArrayBig.field_titolo).link).queryParams">
                            <p class="ls-h3-item-title container-upcoming-events__container-card__left-box__box-bottom__text text-brand-10 ls-h3-item-title cursor-pointer"
                                [innerHTML]="setTitle(eventsDataArrayBig.field_titolo).title">
                            </p>
                        </a>
                        <a *ngIf="nodeService.verifyLinkExternal(setTitle(eventsDataArrayBig.field_titolo).link)"
                            [href]="setTitle(eventsDataArrayBig.field_titolo).link">
                            <p class="ls-h3-item-title container-upcoming-events__container-card__left-box__box-bottom__text text-brand-10 ls-h3-item-title cursor-pointer"
                                [innerHTML]="setTitle(eventsDataArrayBig.field_titolo).title">

                            </p>
                        </a>
                    </div>
                    <a *ngIf="!nodeService.verifyLinkExternal(setTitle(eventsDataArrayBig.field_titolo).link)"
                        [routerLink]="navigationService.splitUrlRouterLink(setTitle(eventsDataArrayBig.field_titolo).link).path" [queryParams]="navigationService.splitUrlRouterLink(setTitle(eventsDataArrayBig.field_titolo).link).queryParams">
                        <div
                            class="m-0 container-upcoming-events__container-card__left-box__box-bottom__cta line-discover-with-icon text-brand-40">
                            <p class="ls-label-medium-semibold">{{"FIND_OUT" | translate}}</p>
                            <i class="fa-solid fa-arrow-right pb-4"  aria-hidden="true"></i>
                        </div>
                    </a>
                    <a *ngIf="nodeService.verifyLinkExternal(setTitle(eventsDataArrayBig.field_titolo).link)"
                        [href]="setTitle(eventsDataArrayBig.field_titolo).link">
                        <div
                            class="m-0 container-upcoming-events__container-card__left-box__box-bottom__cta line-discover-with-icon text-brand-40">
                            <p class="ls-label-medium-semibold">{{"FIND_OUT" | translate}}</p>
                            <i class="fa-solid fa-arrow-right pb-4" aria-hidden="true"></i>
                        </div>
                    </a>
                </div>
            </div>
            <!-- End box left -->
            <!-- Box right -->
            <div
                class="container-upcoming-events__container-card__right-box col-6 d-flex flex-column justify-content-between">
                <div class="container-upcoming-events__container-card__right-box__general d-flex flex-column p-2">
                    <ng-container *ngFor="let eventsSmall of eventsDataArraySmall; let idx = index;">
                        <app-sample-events-small [class.mb-3]="idx === 0" [block]="eventsSmall"
                            [labelLinkUrl]="block.link ? block.link.url : ''">
                        </app-sample-events-small>
                    </ng-container>
                </div>
            </div>
            <!-- End box right -->
        </div>
        <!-- END DESKTOP -->
        <!-- MOBILE -->
        <div class="d-block d-md-none">
            <ng-container *ngIf="eventsDataArrayAll && eventsDataArrayAll.length">
                <owl-carousel-o [options]="customOptionsNews" id="carousel-upcoming">
                    <ng-container *ngFor="let item of eventsDataArrayAll; let idx = index;">
                        <ng-template carouselSlide>
                            <div class="p-2">
                                <app-sample-events-small [block]="item"></app-sample-events-small>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </ng-container>
            <div class="mt-3">
                <a *ngIf="!nodeService.verifyLinkExternal(block.link.url)"
                    [routerLink]="block.link ? block.link.url : ''">
                    <button class="btn-header-news-custom w-100 ls-label-small-semibold"
                        [innerHTML]="block.label_link"></button>
                </a>
                <a *ngIf="nodeService.verifyLinkExternal(block.link.url)" [href]="block.link ? block.link.url : ''">
                    <button class="btn-header-news-custom w-100 ls-label-small-semibold"
                        [innerHTML]="block.label_link"></button>
                </a>
            </div>
        </div>
        <!-- END MOBILE -->
    </div>
</div>
<div class="card-event-no-print w-100">
    <ng-container *ngFor="let event of allEvents">
        <div>
            <div>
                <p *ngIf="setTitle(event.field_titolo)" class="ls-h3-item-title" [innerHTML]="setTitle(event.field_titolo).title"></p>
            </div>
            <div>
                <div *ngIf="event.field_tipologia_evento" class="text-brand-10">
                    <p class="m-0 ls-label-small-semibold text-uppercase">{{ event.field_tipologia_evento }}</p>
                </div>
                <div>
                    <div class="">
                        <div *ngIf="event.content_type === 'Archivio Evento'"
                        class="position-absolute text-white container-upcoming-events__container-card__left-box__title">
                        <div *ngIf="event.field_data_inizio" class="container-upcoming-events__container-card__left-box__title__date">
                            <p *ngIf="event.field_data_inizio && event.field_data_fine" class="m-0 ls-label-large ms-1">
                                {{"BLOCK.SAMPLE_EVENTS.FROM" | translate}}
                            </p>
                            <p *ngIf="event.field_data_inizio" class="m-0 text-garamond ls-label-xxx-large text-uppercase" [attr.role]="'heading'">
                                {{ nodeService.retrieveDateTime(event.field_data_inizio, 'datetime') | localizedDate: 'dd MMM YY' }}
                            </p>
                            <ng-container *ngIf="event.field_data_fine && 
                                                (nodeService.retrieveDateTime(event.field_data_inizio, 'datetime') !== nodeService.retrieveDateTime(event.field_data_fine, 'datetime'))
                                ">
                                <p class="m-0 ls-label-large ms-1">{{"BLOCK.SAMPLE_EVENTS.TO" | translate}}</p>
                                <p class="m-0 text-garamond ls-label-xxx-large text-uppercase" [attr.role]="'heading'">
                                    {{ nodeService.retrieveDateTime(event.field_data_fine, 'datetime') | localizedDate: 'dd MMM YY' }}
                                </p>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngIf="event.field_tipologia_evento === 'Online'"
                        class="position-absolute text-white container-upcoming-events__container-card__left-box__title">
                        <div class="container-upcoming-events__container-card__left-box__title__month">
                            <p *ngIf="event.field_data_inizio" class="mb-2 text-garamond ls-label-xxx-large text-uppercase">
                                {{ nodeService.retrieveDateTime(event.field_data_inizio, 'datetime') | localizedDate: 'dd MMM YY' }}
                            </p>
                        </div>
                        <div class="container-upcoming-events__container-card__left-box__title__hours">
                            <p class="m-0 ls-label-large">
                                <ng-container *ngIf="event.field_orario_inizio && event.field_orario_inizio.trim()">{{"BLOCK.SAMPLE_EVENTS.FROM_HOUR" | translate}} {{ event.field_orario_inizio }}</ng-container>
                                <ng-container *ngIf="event.field_orario_fine && event.field_orario_fine.trim()"> {{"BLOCK.SAMPLE_EVENTS.TO_HOUR" | translate}} {{ event.field_orario_fine }}</ng-container>
                            </p>
                        </div>
                        <div *ngIf="event.field_nome_location"
                            class="container-upcoming-events__container-card__left-box__title__location">
                            <p class="m-0 ls-label-large-semibold">{{ event.field_nome_location }}</p>
                        </div>
                    </div>
                    <div *ngIf="event.field_tipologia_evento === 'In presenza' || block.field_tipologia_evento === 'In presenza/Online'"
                        class="position-absolute text-white container-upcoming-events__container-card__left-box__title">
                        <div class="container-upcoming-events__container-card__left-box__title__date">
                            <p *ngIf="event.field_data_inizio && event.field_data_fine" class="m-0 ls-label-large ms-1">
                                {{"BLOCK.SAMPLE_EVENTS.FROM" | translate}}
                            </p>
                            <p *ngIf="event.field_data_inizio" class="m-0 text-garamond ls-label-xxx-large text-uppercase" [attr.role]="'heading'">
                                {{ nodeService.retrieveDateTime(event.field_data_inizio, 'datetime') | localizedDate: 'dd MMM YY' }}
                            </p>
                            <ng-container *ngIf="event.field_data_fine && 
                                            (nodeService.retrieveDateTime(event.field_data_inizio, 'datetime') !== nodeService.retrieveDateTime(event.field_data_fine, 'datetime'))
                            ">
                                <p class="m-0 ls-label-large ms-1">
                                    {{"BLOCK.SAMPLE_EVENTS.TO" | translate}}
                                </p>
                                <p class="m-0 text-garamond ls-label-xxx-large text-uppercase" [attr.role]="'heading'">
                                    {{ nodeService.retrieveDateTime(event.field_data_fine, 'datetime') | localizedDate: 'dd MMM YY' }}
                                </p>
                            </ng-container>
                        </div>
                        <div class="container-upcoming-events__container-card__left-box__title__hours">
                            <p class="m-0 ls-p ms-1">
                                <ng-container *ngIf="event.field_orario_inizio && event.field_orario_inizio.trim()">{{"BLOCK.SAMPLE_EVENTS.FROM_HOUR" | translate}} {{ event.field_orario_inizio }}</ng-container>
                                <ng-container *ngIf="event.field_orario_fine && event.field_orario_fine.trim()"> {{"BLOCK.SAMPLE_EVENTS.TO_HOUR" | translate}} {{ event.field_orario_fine }}</ng-container>
                            </p>
                        </div>
                    </div>
                    </div>
                    <div *ngIf="event.field_nome_location" class="text-brand-10">
                        <p class="m-0 ls-label-large-semibold" [innerHTML]="event.field_nome_location"></p>
                    </div>
                </div>
            </div>
        </div>
</ng-container>
</div>